// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2tYC5","type":"styles_type__2aTOM","choices":"styles_choices__2i4Z-"};